export default function TopBanner() {
  return (
    <div className="bg-primary text-green-100 py-2 w-full sticky top-0 right-0 left-0 z-50">
      <div className="container mx-auto max-w-6xl flex items-center justify-center h-full px-4 md:px-6">
        <h2 className="text-sm md:text-base">توصيل مجاني على جميع المنتجات</h2>
      </div>
    </div>
  );
}
